import { motion } from "framer-motion";

/**
 * Animated, theme-aware browser-extension side-panel mockup: a page being
 * saved with one click, AI tags filling in. Replaces extension-sidepanel
 * screenshots.
 */

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.3 } },
};
const item = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export const ExtensionMock = ({ className = "" }) => {
  return (
    <motion.div
      className={`obm-mock obm-mock--extension ${className}`}
      variants={container}
      initial={false}
      animate="show"
    >
      <div className="obm-mock__chrome">
        <span className="obm-mock__dot" style={{ background: "#ef4444" }} />
        <span className="obm-mock__dot" style={{ background: "#f59e0b" }} />
        <span className="obm-mock__dot" style={{ background: "#10b981" }} />
        <div className="obm-mock__omnibox">developer.mozilla.org</div>
        <span className="obm-mock__ext-pin">
          <i className="bi bi-bookmark-heart-fill" />
        </span>
      </div>

      <div className="obm-mock__ext">
        <div className="obm-mock__ext-page" aria-hidden="true">
          <div className="obm-mock__skel obm-mock__skel--lg" />
          <div className="obm-mock__skel" />
          <div className="obm-mock__skel obm-mock__skel--sm" />
          <div className="obm-mock__skel" />
          <div className="obm-mock__skel obm-mock__skel--sm" />
        </div>

        <motion.div className="obm-mock__ext-panel" variants={container}>
          <motion.div className="obm-mock__ext-head" variants={item}>
            <i className="bi bi-bookmark-plus-fill" />
            Save to onBookmarks
          </motion.div>

          <motion.div className="obm-mock__item" variants={item}>
            <span className="obm-mock__fav" style={{ background: "#10b981" }}>
              M
            </span>
            <div className="obm-mock__meta">
              <span className="obm-mock__title">MDN Web Docs</span>
              <span className="obm-mock__domain">developer.mozilla.org</span>
            </div>
          </motion.div>

          <motion.div className="obm-mock__chips" variants={item}>
            <span className="obm-mock__chip is-active">
              <i className="bi bi-plus-lg me-1" />
              Development
            </span>
            <span className="obm-mock__chip">Reference</span>
          </motion.div>

          <motion.div className="obm-mock__ext-btn" variants={item}>
            <i className="bi bi-check-lg me-1" />
            Saved
          </motion.div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ExtensionMock;
